import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMobile } from "../hooks/useMobile";
import { serviceList } from "../data/services";
import {
  KAP, Dugme, Dizin, DizinSatir,
  ALTIN_KOYU, INK, INK_2, INK_3, CIZGI, DISPLAY, GOVDE,
  BLOK,} from "../components/Ui";

/* =============================================================
   404: SAYFA BULUNAMADI

   Eskiden bilinmeyen her adres ana sayfaya YÖNLENDİRİLİYORDU
   (`<Route path="*" element={<Navigate to="/" />}`). Bu iki şeyi
   birden bozuyor:
     1. Ziyaretçi yanlış adrese gittiğini anlamıyor, ana sayfada
        neden olduğunu bilmeden buluyor kendini.
     2. Arama motoru silinmiş sayfayı "var ve içeriği ana sayfayla
        aynı" diye görüyor. Buna yumuşak 404 deniyor ve kopya içerik
        sayılıp sıralamayı düşürüyor.

   Artık gerçek bir 404 sayfası var: durumu söylüyor, noindex
   veriyor ve ziyaretçiyi boş bırakmayıp yola sokuyor.

   NOT: Tek sayfa uygulaması olduğu için HTTP durum kodunu tarayıcı
   tarafı veremez. Gerçek 404 kodu sunucudan verilir; taşımadan
   sonra Caddy yapılandırmasında bilinen rotalar dışına 404 dönülür.
   Şimdilik noindex etiketi arama motoruna doğru sinyali veriyor.
   ============================================================= */

export default function NotFoundPage({ onNavigate }) {
  const mobil = useMobile();
  const navigate = useNavigate();
  const konum = useLocation();

  useEffect(() => {
    document.title = "Sayfa bulunamadı | Whayns Dijital";
    let m = document.querySelector('meta[name="robots"]');
    const vardi = !!m;
    const eski = m ? m.getAttribute("content") : null;
    if (!m) {
      m = document.createElement("meta");
      m.setAttribute("name", "robots");
      document.head.appendChild(m);
    }
    m.setAttribute("content", "noindex, follow");
    // Sayfadan çıkarken eski değeri geri koy, yoksa diğer sayfalar da
    // noindex kalır ve site aramadan tamamen düşer.
    return () => {
      if (vardi && eski !== null) m.setAttribute("content", eski);
      else if (m && m.parentNode) m.parentNode.removeChild(m);
    };
  }, []);

  const git = (yol) => (e) => { e.preventDefault(); navigate(yol); };

  return (
    <div>
      <section style={{
        background: BLOK, color: "#FBFAF6",
        padding: mobil ? "72px 0 80px" : "110px 0 120px",
      }}>
        <div style={KAP}>
          <p className="sayi" style={{
            fontFamily: DISPLAY, fontSize: 13, fontWeight: 700,
            letterSpacing: "0.16em", color: "#D2A54A", marginBottom: 20,
          }}>404</p>
          <h1 style={{
            fontSize: mobil ? "clamp(32px,8vw,46px)" : "clamp(38px,5vw,68px)",
            maxWidth: "16ch", color: "#FBFAF6",
          }}>
            Bu sayfa yok. <span style={{ color: "#D2A54A" }}>Ama aradığınız var.</span>
          </h1>
          <p style={{
            fontFamily: GOVDE, fontSize: mobil ? 16 : 18, marginTop: 22,
            color: "rgba(251,250,246,.66)", maxWidth: "52ch", lineHeight: 1.65,
          }}>
            Adres yanlış yazılmış ya da sayfa kaldırılmış olabilir.
            Aşağıdan devam edebilirsiniz.
          </p>
          <p style={{
            fontFamily: GOVDE, fontSize: 13.5, marginTop: 16,
            color: "rgba(251,250,246,.42)", wordBreak: "break-all",
          }}>
            Denenen adres: {konum.pathname}
          </p>
          <div style={{ marginTop: 30, display: "flex", gap: 12, flexWrap: "wrap" }}>
            <Dugme tur="altin" href="/" onClick={git("/")}>Ana sayfaya dön</Dugme>
            <Dugme tur="hayalet" href="/iletisim" onClick={git("/iletisim")}>Bize yazın</Dugme>
          </div>
        </div>
      </section>

      <section style={{ padding: mobil ? "56px 0" : "84px 0" }}>
        <div style={KAP}>
          <h2 style={{ fontSize: "clamp(26px,3vw,38px)", marginBottom: 6 }}>
            Belki bunlardan birini arıyordunuz
          </h2>
          <p style={{ fontFamily: GOVDE, fontSize: 16, color: INK_2, marginBottom: 16 }}>
            Dokuz hizmet alanının tamamı aşağıda.
          </p>
          <Dizin>
            {serviceList.map((s, i) => (
              <DizinSatir
                key={s.id}
                no={String(i + 1).padStart(2, "0")}
                baslik={s.title.replace(/\s*&\s*/g, " ve ")}
                aciklama={s.desc}
                href={`/hizmetler/${s.id}`}
                onClick={git(`/hizmetler/${s.id}`)}
              />
            ))}
          </Dizin>
          <div style={{
            marginTop: 26, paddingTop: 20, borderTop: `1px solid ${CIZGI}`,
            display: "flex", gap: 22, flexWrap: "wrap",
            fontFamily: GOVDE, fontSize: 15,
          }}>
            {[["Hakkımızda", "/hakkimizda"], ["Blog", "/blog"], ["İletişim", "/iletisim"]]
              .map(([et, yol]) => (
                <a key={yol} href={yol} onClick={git(yol)}
                   style={{ color: ALTIN_KOYU, fontWeight: 600 }}>{et}</a>
              ))}
            <span style={{ color: INK_3 }}>ya da menüden gezinin</span>
          </div>
        </div>
      </section>
    </div>
  );
}
